import styled from 'styled-components';
import { Link } from 'react-router-dom';

const LINK_STYLES = `
  display: flex;
  align-items: center;
  font-weight: bold;
  text-decoration: none;
  line-height: 40px;

  & svg {
    width: 31px;
    height: 32px;
    vertical-align: middle;

    & path {
      fill: #484848;
    }
  }

  @media (max-width: 959px) {
    justify-content: center;
  }
`;

const CompanyLink = styled.a`
  ${LINK_STYLES}
`;

export const CompanyRouterLink = styled(Link)`
  ${LINK_STYLES}
`;

export default CompanyLink;
